import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import BarLoader from "react-spinners/BarLoader";
import Moment from "react-moment";
import Highlighter from "react-highlight-words";
import { TiArrowSortedDown } from "react-icons/ti";
// import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import PageHeader from "../../../../components/page-header/PageHeader";
import Pagination from "../../../../../../shared/components/ui/pagination/Pagination";
import {
  ArchiveSubsection,
  useWorkshops,
} from "../../../../../../contexts/workshops-context/WorkshopsContext";
import { getCountryString } from "../../../../../../shared/utils/Commons";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";
import { useFunctions } from "reactfire";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import { useHistory } from "react-router";
import { DashboardPages } from "../../..";

const ITEM_COUNT_IN_PAGE: number = 10;
interface Orders {
  current: "WORKSHOP_NAME";
  workshopName: "ASCENDING" | "DESCENDING";
}

interface Filter {
  workshopName: string;
  year: number;
}

const initialFilters: Filter = {
  workshopName: "",
  year: -1,
};
const initialOrders: Orders = {
  workshopName: "ASCENDING",
  current: "WORKSHOP_NAME",
};
const initialPagination = {
  total_pages: 0,
  page_number: 0,
};
const ArchivedSubsections = () => {
  // const appUser = useAppUser();
  const { push } = useHistory();
  const [fArchivedSections, setFArchivedSections] = useState<
    ArchiveSubsection[]
  >([]);
  const [selectedSection, setSelectedSection] = useState<ArchiveSubsection>();
  const [filterState, setFilterState] = useState(initialFilters);
  const [orderState, setOrderState] = useState(initialOrders);
  const [pagination, setPagination] = useState(initialPagination);
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const { archivedSections } = useWorkshops();
  const restoreSectionRef = useFunctions().httpsCallable(
    "updateSubSectionArchiveStatus"
  );

  useEffect(() => {
    if (fArchivedSections.length % ITEM_COUNT_IN_PAGE === 0) {
      const totalPages = fArchivedSections.length / ITEM_COUNT_IN_PAGE;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    } else {
      const totalPages =
        Math.floor(fArchivedSections.length / ITEM_COUNT_IN_PAGE) + 1;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    }
  }, [fArchivedSections]);

  useEffect(() => {
    let c_sections = archivedSections;
    switch (orderState.current) {
      case "WORKSHOP_NAME":
        if (orderState.workshopName === "ASCENDING") {
          c_sections.sort((a, b) => {
            if (a.workshopName && b.workshopName) {
              return b.workshopName?.toLowerCase() >
                a.workshopName?.toLowerCase()
                ? -1
                : 1;
            } else {
              return 0;
            }
          });
        } else {
          c_sections.sort((a, b) => {
            if (a.workshopName && b.workshopName) {
              return b.workshopName?.toLowerCase() <
                a.workshopName?.toLowerCase()
                ? -1
                : 1;
            } else {
              return 0;
            }
          });
        }
        break;

      default:
        if (orderState.workshopName === "ASCENDING") {
          c_sections.sort((a, b) => {
            if (a.workshopName && b.workshopName) {
              return b.workshopName?.toLowerCase() >
                a.workshopName?.toLowerCase()
                ? -1
                : 1;
            } else {
              return 0;
            }
          });
        } else {
          c_sections.sort((a, b) => {
            if (a.workshopName && b.workshopName) {
              return b.workshopName?.toLowerCase() <
                a.workshopName?.toLowerCase()
                ? -1
                : 1;
            } else {
              return 0;
            }
          });
        }
        break;
    }
    if (filterState.workshopName.trim().length > 0) {
      c_sections = c_sections.filter((application) =>
        application.workshopName
          ?.toLowerCase()
          .includes(filterState.workshopName.toLowerCase())
      );
    }

    if (filterState.year > 0) {
      c_sections = c_sections.filter(
        (s) => s.createdAt.getFullYear() === filterState.year
      );
    }

    setFArchivedSections((ps) => {
      return c_sections;
    });
  }, [
    filterState.workshopName,
    filterState.year,
    archivedSections,
    orderState,
  ]);

  const restoreSection = () => {
    if (selectedSection) {
      setLoading(true);
      restoreSectionRef({
        workshopId: selectedSection?.workshopId,
        sectionId: selectedSection?.subsectionId,
      })
        .then(() => {
          UserNotification({
            isSuccess: true,
            message: "Subsection restored success!",
          });
        })
        .catch(() => {
          UserNotification({
            isSuccess: false,
            message: "Subsection restore failed!",
          });
        })
        .finally(() => {
          setLoading(false);
          setShowDialog(false);
        });
    }
  };

  const paginate = (
    array: ArchiveSubsection[],
    page_number: number,
    page_size: number
  ): ArchiveSubsection[] => {
    if (array.length > 0) {
      return array.slice(
        page_number * page_size,
        (page_number + 1) * page_size
      );
    } else {
      return [];
    }
  };

  const currentYear = new Date().getFullYear();

  const range = (start: number, stop: number, step: number) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );

  return (
    <div>
      <PageHeader sidebarOnly={true} title="Archived Subsections" />
      <Container
        fluid
        style={{
          paddingTop: "210px",
          paddingLeft: "65px",
          paddingRight: "50px",
          paddingBottom: "10px",
        }}
      >
        <Row>
          <Col
            xs={12}
            md={3}
            xl={3}
            className="d-flex align-items-center ml-md-0 my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <input
                className="app-input input-small search-img"
                style={{ paddingRight: "30px" }}
                placeholder="Workshop Name"
                value={filterState.workshopName}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    workshopName: e.target.value,
                  });
                }}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={3}
            xl={3}
            className="d-flex align-items-center ml-md-0 my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                value={filterState.year}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    year: parseInt(e.target.value),
                  });
                }}
              >
                <option key={0} value={-1}>
                  All
                </option>
                {range(currentYear - 10, currentYear, 1).map((y, i) => (
                  <option key={i + 1} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
          </Col>

          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <button
                className="app-button"
                style={{
                  backgroundColor: "#6c757d",
                  padding: "3px 10px 3px 10px",
                }}
                onClick={() => setFilterState(initialFilters)}
              >
                Clear filters
              </button>
            </div>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={12}>
            <BarLoader
              height={4}
              width={"100%"}
              color={"#006699"}
              loading={false}
            />
          </Col>
        </Row>
        <Row className="mt-2 scroll" style={{ overflowX: "auto" }}>
          <Col xs={12} style={{ minHeight: "660px" }}>
            <table className="table-applications">
              <colgroup>
                <col span={1} style={{ width: "30%" }}></col>
                <col span={1} style={{ width: "20%" }}></col>
                <col span={1} style={{ width: "10%" }}></col>
                <col span={1} style={{ width: "10%" }}></col>
                <col span={1} style={{ width: "20%" }}></col>
                <col span={1} style={{ width: "10%" }}></col>
              </colgroup>
              <thead>
                <tr>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setOrderState({
                        ...orderState,
                        current: "WORKSHOP_NAME",
                        workshopName:
                          orderState.workshopName === "ASCENDING"
                            ? "DESCENDING"
                            : "ASCENDING",
                      });
                    }}
                  >
                    Workshop name
                    <TiArrowSortedDown
                      className="order-arrow"
                      style={
                        orderState.current === "WORKSHOP_NAME"
                          ? orderState.workshopName === "ASCENDING"
                            ? { transform: "rotate(0deg)" }
                            : {
                                transform: "rotate(180deg) translateY(2px)",
                              }
                          : { color: "#aaa" }
                      }
                    />
                  </th>
                  <th style={{ cursor: "pointer" }}>Subsection name</th>
                  <th>Created date</th>
                  <th>Archived date</th>
                  <th style={{ cursor: "pointer" }} onClick={() => {}}>
                    Country
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginate(
                  fArchivedSections,
                  pagination.page_number,
                  ITEM_COUNT_IN_PAGE
                ).map((section, index: number) => (
                  <tr
                    key={index}
                    className="link-label-application"
                    onClick={() => {
                      push(
                        DashboardPages.DIRECT_ARCHIVED_WORKSHOP.replace(
                          ":id",
                          section.workshopId
                        )
                      );
                    }}
                  >
                    <td>
                      <Highlighter
                        highlightClassName="highlightClass"
                        searchWords={[filterState.workshopName || ""]}
                        highlightTag={({ children, highlightIndex }: any) => {
                          return (
                            <span className="highlightClass">{children}</span>
                          );
                        }}
                        autoEscape={true}
                        textToHighlight={section.workshopName || ""}
                      />
                    </td>
                    <td>{section.subsectionName}</td>
                    <td>
                      <Moment format="MM/DD/YYYY">{section.createdAt}</Moment>
                    </td>
                    <td>
                      <Moment format="MM/DD/YYYY">{section.archivedAt}</Moment>
                    </td>
                    <td>{getCountryString(section.country)}</td>
                    <td style={{ color: "#2ECC71", fontSize: "24px" }}>
                      <button
                        className="app-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSection(section);
                          setShowDialog(true);
                        }}
                      >
                        Restore
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
          <Col xs={12}>
            <Pagination
              pInfo={{
                page: pagination.page_number,
                totalPages: pagination.total_pages,
              }}
              onPageChanged={(page) => {
                setPagination((ps) => ({ ...ps, page_number: page }));
              }}
            />
          </Col>
        </Row>
        <ConfirmationModal
          children={{
            bodyText: "Are you sure you want to restore this section?",
            headerText: "Restore",
            confirmButtonText: "Restore",
            cancelButtonText: "Cancel",
            confirmButtonColor: loading ? "grayStatic" : "green",
          }}
          loading={loading}
          show={showDialog}
          onCancel={() => {
            setShowDialog(false);
          }}
          onConfirm={() => restoreSection()}
        />
      </Container>
    </div>
  );
};

export default ArchivedSubsections;
